import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import NumberFormat from 'react-number-format';

import { numberFormat } from 'constants/formats';

import { Range } from 'types';

type Props = {
  validRanges: Range[];
  handleClickRange: (range: Range) => void; // eslint-disable-line
};

const ShareEncumbranceViewFormAvailableRanges: FC<Props> = ({
  validRanges,
  handleClickRange,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <div className="row">
        <div className="col-12 d-flex">
          {validRanges?.length > 0 && (
            <>
              <div className="form-label mb-0">{t('Available')}:</div>

              {validRanges
                .filter((range: Range) => range?.to > range?.from)
                .map((range: Range) => (
                  <b
                    key={range?.from}
                    className="badge rounded btn-primary ml-1 cursor-pointer align-items-center"
                    onClick={() => handleClickRange(range)}
                  >
                    <NumberFormat
                      displayType="text"
                      value={range?.from}
                      thousandSeparator={numberFormat.thousandSeparator}
                      decimalSeparator={numberFormat.decimalSeparator}
                    />
                    &nbsp;-&nbsp;
                    <NumberFormat
                      displayType="text"
                      value={range?.to}
                      thousandSeparator={numberFormat.thousandSeparator}
                      decimalSeparator={numberFormat.decimalSeparator}
                    />
                    &nbsp;
                  </b>
                ))}
            </>
          )}
        </div>

        <div className="col-12">
          <span className="sub-text">
            {validRanges?.length > 0 && (
              <i className="text-soft">{t('AvailableSharesInfo')}</i>
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export default ShareEncumbranceViewFormAvailableRanges;
